import { InputField } from "@ps-design-system/components/Input";

import { useIntl } from "react-intl-compat";

type FoodAndDrinkMinimumFieldProps = {
  currencySymbol: string;
  onBlur: () => void;
  onFocus: () => void;
};

/** The FSV food and drink minimum amount input. */
const FoodAndDrinkMinimumField = ({
  currencySymbol,
  onBlur,
  onFocus,
}: FoodAndDrinkMinimumFieldProps) => {
  const intl = useIntl();

  return (
    // InputField overrides its own onBlur with the form's, so listen here
    <div className="tw-mb-16 tw-w-128" onBlur={onBlur} onFocus={onFocus}>
      <InputField
        fullWidth
        name="foodAndDrinkMinimum"
        label={intl.formatMessage({
          id: "hosting.listing_fsv.food_and_drink_minimum_label",
          defaultMessage: "Food and drink minimum",
        })}
        subcopy={intl.formatMessage({
          id: "hosting.listing_fsv.food_and_drink_minimum_subcopy",
          defaultMessage:
            "The minimum amount guests commit to spending at the venue.",
        })}
        type="number"
        min={0}
        step={1}
        prefix={currencySymbol}
        testId="fsv-form-food-and-drink-minimum-input"
      />
    </div>
  );
};

export { FoodAndDrinkMinimumField };
